module.exports = __webpack_public_path__ + "img/img21.1b5105f0.png";